import $api from "../../../axios"
import { IProjectData } from "../types/projectData.types"

const projectsPath = "/projects/asins"

const getAsinsData = async (projectId: string): Promise<IProjectData[]> => {
  const response = await $api.get(projectsPath + "/", { params: { projectId } })
  return response.data
}

const addAsins = async (projectId: string, asins: string[]): Promise<IProjectData[]> => {
  const response = await $api.post(projectsPath + "/addAsins", { projectId, asins })
  return response.data
}

export default {
  getAsinsData,
  addAsins,
}
